import { IngredientsApi } from './ingredients/ingredients'
import { applyMixins } from './utils'
import { Base } from './base'

class Client extends Base { }
interface Client extends IngredientsApi { }
applyMixins(Client, [IngredientsApi]);

export default Client